import React, { useEffect, useState, useRef, useContext } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Button from "react-bootstrap/Button";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { ApiService } from "../../Components/Services/apiservices";
import { BrowserView, MobileView } from "react-device-detect";
import AccountSidebar from "./account_sidebar";
import SpinnerLoader from "../../Components/Elements/spinner_loader";
import { useNavigate } from "react-router-dom";
import MobileHeader from "../../Components/Elements/mobile_header";
import AddressModal from "../../Components/Modals/address_modal";
import sessionCartData from "../../Components/Elements/cart_session_data";
import DataContext from "../../Components/Elements/eventContext";
function Address() {
  const contextValues= useContext(DataContext)
  const didMountRef = useRef(true);
  const [rowUserData, setRowUserData] = useState({});
  const [resUserAddress, setResUserAddress] = useState([]);
  const [spinnerLoading, setSpinnerLoading] = useState(true);
  const [countryData, setCountryData] = useState([]);
  const [EditAddrData, setEditAddrData] = useState();
  const dataArray = sessionCartData();
  const parsedCartSession = dataArray[1];
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  
  const handleChildData = (status) => {
    setShow(status);
  };
  useEffect(() => {
    if (didMountRef.current) {
      getuserData();
      getUserAddress();
      getCountryData();
    }
    didMountRef.current = false;
  }, []);

  const getuserData = () => {
    ApiService.fetchData("get-user-data").then((res) => {
      if (res.status === "success") {
        setRowUserData(res.rowUserData);
        setSpinnerLoading(false);
      } else {
        localStorage.removeItem("USER_TOKEN");
        setSpinnerLoading(false);
        navigate("/");
      }
    });
  };
  const getUserAddress = () => {
    ApiService.fetchData("get-user-address").then((res) => {
      if (res.status === "success") {
        setResUserAddress(res.resUserAddress);
        setSpinnerLoading(false);
      }
    });
  };

  const getCountryData = () => {
    ApiService.fetchData("get-country").then((res) => {
      if (res.status == "success") {
        setCountryData(res.data);
      }
    });
  };

  const deleteaddress = (value) => {
    if (window.confirm("Are you sure?")) {
      const dataString = {
        addrid: value,
      };
      ApiService.postData("removeAddress", dataString).then((res) => {
        if (res.status == "success") {
          getUserAddress();
          // setcityData(res.data)
        }
      });
    } else {
    }
  };
  const addressModal = () => {
    contextValues.setToggleCheckoutAddressModal(!contextValues.toggleCheckoutAddressModal)
}

const [userAddressDetails, setUserAddressDetails] = useState({
  ua_id: 0,
  ua_fname: "",
  ua_lname: "",
  ua_email: "",
  ua_mobile: "",
  ua_pincode: "",
  ua_house_no: "",
  ua_state_id: "",
  ua_city_id: "",
  ua_state_name: "",
  ua_city_name: "",
  ua_country_id: "13",
  ua_address_type: "",
  ua_address_type_other: "",
  ua_bill_fname: "",
  ua_bill_lname: "",
  ua_bill_email: "",
  ua_bill_mobile: "",
  ua_bill_pincode: "",
  ua_bill_house_no: "",
  ua_bill_state_id: "",
  ua_bill_city_id: "",
  ua_bill_state_name: "",
  ua_bill_city_name: "",
  ua_bill_country_id: "13",
  ua_billing_address_check: true
 
});

const editaddress = (value) => {
    setUserAddressDetails({
      ua_id: value.ua_id,
      ua_fname: value.ua_fname,
      ua_lname: value.ua_lname,
      ua_email: value.ua_email,
      ua_mobile: value.ua_mobile,
      ua_pincode: value.ua_pincode,
      ua_house_no: value.ua_house_no,
      ua_state_id: value.ua_state_id,
      ua_city_id: value.ua_city_id,
      ua_state_name: value.ua_state_name,
      ua_city_name: value.ua_city_name,
      ua_country_id: "13",
      ua_address_type: value.ua_address_type,
      ua_address_type_other: value.ua_address_type_other,
      ua_bill_fname: value.ua_bill_fname,
      ua_bill_lname: value.ua_bill_lname,
      ua_bill_email: value.ua_bill_email,
      ua_bill_mobile: value.ua_bill_mobile,
      ua_bill_pincode: value.ua_bill_pincode,
      ua_bill_house_no: value.ua_bill_house_no,
      ua_bill_state_id: value.ua_bill_state_id,
      ua_bill_city_id: value.ua_bill_city_id,
      ua_bill_state_name: value.ua_bill_state_name,
      ua_bill_city_name: value.ua_bill_city_name,
      ua_bill_country_id: "13",
      ua_billing_address_check: value.ua_billing_address_check
     
    })
    contextValues.setToggleAddressModal(!contextValues.toggleAddressModal)
}


  const toggleAddressModal = () => {
    setUserAddressDetails({
      ua_id: 0,
      ua_fname: "",
      ua_lname: "",
      ua_email: "",
      ua_mobile: "",
      ua_pincode: "",
      ua_house_no: "",
      ua_state_id: "",
      ua_city_id: "",
      ua_state_name: "",
      ua_city_name: "",
      ua_country_id: "13",
      ua_address_type: "",
      ua_address_type_other: "",
      ua_bill_fname: "",
      ua_bill_lname: "",
      ua_bill_email: "",
      ua_bill_mobile: "",
      ua_bill_pincode: "",
      ua_bill_house_no: "",
      ua_bill_state_id: "",
      ua_bill_city_id: "",
      ua_bill_state_name: "",
      ua_bill_city_name: "",
      ua_bill_country_id: "13",
      ua_billing_address_check: true
     
  });
    contextValues.setToggleAddressModal(!contextValues.toggleAddressModal)
}


  return (
    <>
      {spinnerLoading && <SpinnerLoader />}
      <BrowserView>
      <Header state="inner-header" cartCount={parsedCartSession.length}/>

        <main className="main">
          <div className="subheader">
            <Container>
              <Row>
                <Col lg={12}>
                  <Breadcrumb className="breadcrumb-inner">
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>My Address</Breadcrumb.Item>
                  </Breadcrumb>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="page-content mt-4 mb-4">
            <section>
              <Container>
                <Row>
                  <AccountSidebar rowUserData={rowUserData} />
                  <Col lg={9}>
                    <div className="acpanel">
                      <div className="acpanel-header">
                        <h4>My Address</h4>
                      </div>
                      {spinnerLoading === false?
                      <div className="acpanel-body">
                        {resUserAddress.length > 0 ? (
                          <>
                            <div className="row">
                              {resUserAddress.map((value, index) => (
                                <div className="col-lg-6" key={index}>
                                  <div className="addressbox mb-2">
                                    <div className="addressbox-body">
                                      <h6 className="mb-1 tx-13">
                                        {value.ua_fname}  {value.ua_lname}{" "}
                                        {value.ua_default_address == 1
                                          ? "(Default)"
                                          : ""}
                                      </h6>
                                      <p className="mb-1 tx-13">{value.ua_email}</p>
                                      <p className="mb-1 tx-13">
                                        {value.ua_house_no},{" "}
                                        {value.ua_city_name},{" "}
                                        {value.ua_state_name} {value.ua_pincode}
                                      </p>
                                      <p className="mb-0 tx-13">
                                        Mobile No: {value.ua_mobile}
                                      </p>
                                      <div className="addressbox-type">
                                        {value.ua_address_type == "Other"
                                          ? value.ua_address_type_other
                                          : value.ua_address_type}
                                      </div>
                                    </div>
                                    <div className="addressbox-footer">
                                      <a
                                        href="#"
                                        onClick={(e) =>
                                          editaddress(value)
                                        }
                                      >
                                        Edit
                                      </a>
                                      <a
                                        href="#"
                                        onClick={(e) =>
                                          deleteaddress(value.ua_id)
                                        }
                                      >
                                        Delete
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>

                            <Button
                              className="btn btn-primary-outline btn-medium mt-2"
                              onClick={() => {
                               
                                toggleAddressModal();
                              }}
                            >
                              Add New Address
                            </Button>
                          </>
                        ) : (
                          <div className="noimg text-center">
                            <img
                              src="/img/noaddress.png"
                              style={{ width: "250px" }}
                              className="mb-3"
                            />
                            <h6>Save Your Address Now!</h6>
                            <p>
                              Add your home and office addresses and enjoy
                              faster checkout
                            </p>
                            <Button
                              className="btn btn-primary-outline btn-medium btn01"
                              onClick={()=>{toggleAddressModal()}}
                            >
                              Add New Address
                            </Button>
                          </div>
                        )}
                      </div>
                      :null}
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </main>
        <Footer />
      </BrowserView>

      <MobileView>
        <MobileHeader
          PageName="Address Book"
          Route="account/account-overview"
          cartCount={parsedCartSession.length}
        />
        {spinnerLoading === false?
        <main className="main">
        <div className="maddress-header">My Address</div>
        {resUserAddress.length > 0 ? (
          resUserAddress.map((value, index) => (
            <div className="maddressbox">
              <div className="maddressbox-body">
                <h6 className="mb-1 tx-13">
                  {value.ua_fname} {value.ua_lname}{" "}
                  {value.ua_default_address == 1 ? "(Default)" : ""}
                </h6>
                <p className="mb-1 tx-13">{value.ua_email}</p>
                <p className="mb-1 tx-13">
                  {value.ua_house_no}, {value.ua_city_name},{" "}
                  {value.ua_state_name} {value.ua_pincode}
                </p>
                <p className="mb-0 tx-13">Mobile No: {value.ua_mobile}</p>
                <div className="maddressbox-type">
                  {value.ua_address_type == "Other"
                    ? value.ua_address_type_other
                    : value.ua_address_type}
                </div>
              </div>
              <div className="maddressbox-footer">
                <a href="#" onClick={(e) => editaddress(value)}>
                  Edit
                </a>
                <a href="#" onClick={(e) => deleteaddress(value.ua_id)}>
                  Delete
                </a>
              </div>
            </div>
          ))
        ) : (
          <div className="noimg text-center">
            <img
              src="/img/noaddress.png"
              style={{ width: "250px" }}
              className="mb-3"
            />
            <h6>Save Your Address Now!</h6>
            <p>
              Add your home and office addresses and enjoy faster checkout
            </p>
            <Button
              className="btn btn-primary-outline btn-medium btn01"
              onClick={() => {
                toggleAddressModal();
              }}
            >
              Add New Address
            </Button>
          </div>
        )}
        {resUserAddress.length > 0 ? (
          <div className="maddress-footer">
            <Button
              className="btn btn-primary-outline btn-medium btn-block"
              onClick={() => {
               
                toggleAddressModal();
              }}
            >
              Add New Address
            </Button>
          </div>
        ) : (
          ""
        )}
      </main>:null}
        
      </MobileView>
      {contextValues.toggleAddressModal && (
        <AddressModal
          countryData={countryData}
          EditAddrData={userAddressDetails}
        />
      )}
    </>
  );
}
export default Address;
